
import { AxiosResponse } from 'axios';
import { ArtStyle, GetArtStylesResponse } from '../types/ArtStyles';
import { BlogResponse, strapiURL } from '../components/context/BlogContext';

export const PAGE_SIZE = 10;
export const getHostUrl = () => `https://${window.location.host.startsWith('localhost') ? 'alpha.saagas.ai' : window.location.host}`;

export const getKeyMyArtStyles = (pageIndex: number, previousPageData: AxiosResponse<GetArtStylesResponse>) => {
 
  if (!previousPageData) {
    return `${getHostUrl()}/api/art-styles/v1/art-styles?createdBy=me&published=both&offset=${pageIndex * PAGE_SIZE}&size=${PAGE_SIZE}`;
  }

  if (previousPageData && previousPageData.data.artStyles.length < PAGE_SIZE) {
    return null;
  }

  if (previousPageData.config.url?.startsWith(
    `https://${window.location.host.startsWith('localhost') ? 'alpha.saagas.ai' : window.location.host}/api/art-styles/v1/art-styles?`
  )) {
    return `${getHostUrl()}/api/art-styles/v1/art-styles?createdBy=me&published=both&offset=${pageIndex * PAGE_SIZE}&size=${PAGE_SIZE}`;
  }

  return null;
};

export const getKeyPublishedArtStyles = (pageIndex: number, previousPageData: AxiosResponse<GetArtStylesResponse>) => {
 
  if (!previousPageData) {
    return `${getHostUrl()}/api/art-styles/v1/art-styles?offset=${pageIndex * PAGE_SIZE}&size=${PAGE_SIZE}`;
  }

  if (previousPageData && previousPageData.data.artStyles.length < PAGE_SIZE) {
    return null;
  }

  if (previousPageData.config.url?.startsWith(
    `https://${window.location.host.startsWith('localhost') ? 'alpha.saagas.ai' : window.location.host}/api/art-styles/v1/art-styles?`
  )) {
    return `${getHostUrl()}/api/art-styles/v1/art-styles?offset=${pageIndex * PAGE_SIZE}&size=${PAGE_SIZE}`;
  }

  return null;

};

export const getKeyLikedArtStyles = (pageIndex: number, previousPageData: AxiosResponse<ArtStyle[]>) => {
  if (previousPageData && previousPageData.data.length < 10) return null;
  return `/art-styles/v1/art-styles?likedBy=me&offset=${pageIndex * PAGE_SIZE}&size=${PAGE_SIZE}`;
};

export const getKeyMarketplaceLikedArtStyles = (pageIndex: number, previousPageData: AxiosResponse<GetArtStylesResponse>) => {
  if (!previousPageData) {
    return `${getHostUrl()}/api/art-styles/v1/art-styles?includeMine=false&likedBy=me&published=yes&includeProfileArtStyles=false&offset=${pageIndex * PAGE_SIZE}&size=${PAGE_SIZE}`;
  }

  if (previousPageData && previousPageData.data.artStyles.length < PAGE_SIZE) {
    return null;
  }

  if (previousPageData.config.url?.startsWith(
    `https://${window.location.host.startsWith('localhost') ? 'alpha.saagas.ai' : window.location.host}/api/art-styles/v1/art-styles?`
  )) {
    return `${getHostUrl()}/api/art-styles/v1/art-styles?includeMine=false&likedBy=me&published=yes&includeProfileArtStyles=false&offset=${pageIndex * PAGE_SIZE}&size=${PAGE_SIZE}`;
  }

  return null;
};


export const getArtStyles = (pageIndex: number, previousPageData: GetArtStylesResponse | null) => {
  if (previousPageData && previousPageData.artStyles.length === 0) return null;
  return `/art-styles?createdBy=me&published=both&offset=${pageIndex * 10}&size=10`;
};


export const getBlogsKey = (pageIndex: number, previousPageData: BlogResponse | null) => {
  if (previousPageData && previousPageData.data.length === 0) return null;
  return `${strapiURL}/api/blogs?populate=*&pagination[page]=${pageIndex + 1}&pagination[pageSize]=10`;
};
